import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { BaasicButton } from 'core/components';

function NikoFacilityOrderUSIntakeFindAndDeleteConfirmationModalTemplate({ nikoFacilityOrderUSIntakeFindAndDeleteConfirmationModalStore, t }) {
	const {
		modalParams,
		isLoading,
		deleteFacilityOrderTemplateItems,
		patientTemplates
	} = nikoFacilityOrderUSIntakeFindAndDeleteConfirmationModalStore;

	return (
		<section>
			<div className="modal__header">
				<h3 className='modal__header__title'>Are you sure you want to delete this item?</h3>
			</div>
			<div className="modal__body">
				<p>{"Please note that this item is the only item on a patient’s new template and deleting it will delete the full template. If that template is the patient’s only template, the patient will be removed from the facility order. (This may be applicable to multiple templates)."}</p>

				{patientTemplates && patientTemplates.some(i => i) ?
					<div className="u-mar--top--sml">
						<table className="table--preview">
							<thead>
								<tr>
									<th width="50%" className="type--left">PATIENT NAME</th>
									<th width="25%" className="type--left">SUB CATEGORY</th>
									<th width="25%" className="type--left">INACTIVE REASON</th>
								</tr>
							</thead>
							<tbody>
								{patientTemplates.map((patientTemplate) => {
									return (
										<tr key={patientTemplate.id}>
											<td>{patientTemplate.patientName}</td>
											<td>{patientTemplate.subCategoryName}</td>
											<td>{patientTemplate.inactiveReason}</td>
										</tr>
									);
								})}
							</tbody>
						</table>
					</div>
					:
					<React.Fragment></React.Fragment>
				}
			</div>
			<div className='modal__footer is-right'>
				<BaasicButton
					className='btn btn--med btn--light'
					label={t('EDIT_FORM_LAYOUT.CANCEL')}
					disabled={isLoading}
					onClick={() => modalParams.close()}
				/>
				<BaasicButton
					className='btn btn--med btn--warning'
					label={"Delete Anyway"}
					disabled={isLoading}
					onClick={async () => await deleteFacilityOrderTemplateItems()}
					focused={true}
					rotate icon={
						isLoading
							? "u-icon u-icon--xmed u-icon--sync u-rotate--login"
							: 'u-display--none'
					}
				/>
			</div>
		</section>
	)
}

NikoFacilityOrderUSIntakeFindAndDeleteConfirmationModalTemplate.propTypes = {
	nikoFacilityOrderUSIntakeFindAndDeleteConfirmationModalStore: PropTypes.object,
	t: PropTypes.func
};

export default defaultTemplate(NikoFacilityOrderUSIntakeFindAndDeleteConfirmationModalTemplate);